const DEV = false;

const API_URL = DEV ? 'http://localhost:8080' : 'https://api.wordseveryday.net';

const STRIPE_KEY = 'sk_test_51IwM2eHtjOe8PfoKTyjuzpKtZp97gBOYGr4Re2f221pjLAVEIAmLBXnE5AE8QxJvs7ddpFYkuLMexO2eqnzaQfix00T3QAVUai';

export { API_URL, STRIPE_KEY };